import { createContext, useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { http } from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    http.get("/auth/me").then((r) => setUser(r.data)).catch(async () => {
      try {
        await http.post("/auth/refresh");
        const r = await http.get("/auth/me");
        setUser(r.data);
      } catch { setUser(false); }
    });
  }, []);

  const login = async (email, password) => {
    const r = await http.post("/auth/login", { email, password });
    setUser(r.data);
  };
  const logout = async () => {
    await http.post("/auth/logout");
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, login, logout }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);

export const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center text-slate-400" data-testid="auth-loading">Carregando...</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};
